import store from "../../redux/store";
import { TEMP_CALENDAR_ID } from "../../services/calendar-management/components/calendar-section/CalendarSection";
import { getRequest, postRequest } from "../api";

export const getCalendarRedirectUri = async ({
  aliasName,
  provider,
  organizationId,
  accountId,
  credentialsKey = null,
}) => {
  const token = store.getState().info.token;
  var endpoint = `snippet/oauth/redirect?provider=${provider}&aliasName=${aliasName}&organizationId=${organizationId}&accountId=${accountId}`;
  if (credentialsKey) {
    endpoint += `&credentialsKey=${credentialsKey}`;
  }

  try {
    const response = await getRequest({
      endpoint,
      token,
    });
    const redirectResponse = await response.json();

    return redirectResponse.url;
  } catch (error) {
    console.error("Error getting calendar redirect URI", error);
  }

  return null;
};

export const getSecondaryCalendarInfo = async ({
  aliasName,
  calendarId,
  calendarName,
  calendarProvider,
  credentialsKey,
  organizationId,
  accountId,
}) => {
  const token = store.getState().info.token;
  const searchParams = new URLSearchParams();
  searchParams.append("aliasName", aliasName);
  searchParams.append("provider", calendarProvider);
  searchParams.append("organizationId", organizationId);
  searchParams.append("accountId", accountId);

  if (calendarId && calendarId !== TEMP_CALENDAR_ID) {
    searchParams.append("calendarId", calendarId);
  }
  if (calendarName) {
    searchParams.append("name", encodeURIComponent(calendarName));
  }
  if (credentialsKey) {
    searchParams.append("credentialsKey", credentialsKey);
  }

  const endpoint = `snippet/calendar?${searchParams.toString()}`;

  const response = await getRequest({ endpoint, token });
  return response.json();
};

export const getCalendarUserInfo = async ({
  aliasName,
  calendarProvider,
  organizationId,
  accountId,
}) => {
  const token = store.getState().info.token;
  const endpoint = `snippet/oauth/user-info?provider=${calendarProvider}&aliasName=${aliasName}&organizationId=${organizationId}&accountId=${accountId}`;
  const response = await getRequest({ endpoint, token });

  const userInfo = await response.json();
  if (userInfo.error) {
    console.error("Error getting calendar user info", userInfo.error);
    return null;
  }

  return userInfo;
};

export const addSecondaryCalendarInfo = async ({
  aliasName,
  calendarName,
  calendarProvider,
  credentialsKey,
  token: tokenParam,
  organizationId,
  accountId,
}) => {
  const token = tokenParam || store.getState().info.token;
  const endpoint = "snippet/calendar/";
  const request = {
    aliasName: aliasName,
    provider: calendarProvider,
    name: calendarName,
    organizationId: organizationId,
    accountId: accountId,
  };

  if (credentialsKey) {
    request.credentialsKey = credentialsKey;
  }

  const response = await postRequest({ endpoint, data: request, token });
  return response.json();
};

export const getCalendarManagementInfo = async (organizationId, accountId, setupId, tokenParam) => {
  const token = tokenParam || store.getState().info.token;
  var calendarManagementInfo = {};

  try {
    const endpoint = `ucaas/account/setup/appointments?organizationId=${organizationId}&accountId=${accountId}&setupId=${setupId}`;
    const response = await getRequest({
      endpoint: endpoint,
      token: token,
    });

    calendarManagementInfo = await response.json();
  } catch (error) {
    console.error("Error getting calendar management info", error);
  }

  return calendarManagementInfo;
};
